export class Onboarding {
    district: number;
}
